import React from 'react';
import { ArrowDownward, ArrowUpward } from '@mui/icons-material';
import { Box, Card, CardContent, Typography } from '@mui/material';
import { MaintenanceItemEmpty } from '../Dashboard';
import DashboardCardInfo from '../../../Components/common/DashboardCardInfo';

const AccountsCard = ({
    data,
    isLoading = false,
    tooltipTitle
}) => {
    const percentage = Math.abs(
        (
            ((data?.oldActiveAccounts +
                data?.newActiveAccounts) /
                data?.totalAccounts) *
            100
        )?.toFixed(2)
    ) || 0

    const isGrowth = data?.oldActiveAccounts +
        data?.newActiveAccounts >
        data?.inactiveAccounts
    return (
        <Card sx={{ borderRadius: 2 }}>
            {
                isLoading ? <CardContent>
                    <MaintenanceItemEmpty />
                </CardContent> :
                    <CardContent sx={{ position: "relative", paddingBottom: "40px !important" }}>
                        <Typography variant="h5" color="text.primary" sx={{ fontWeight: "500" }} gutterBottom>
                            Accounts
                        </Typography>
                        <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
                            <Typography
                                variant="subtitle1"
                                color="text.primary"
                                sx={{ fontWeight: 'bold', fontStyle: 'italic' }}
                            >
                                Active Accounts  <strong style={{ color: "green" }}>{data?.oldActiveAccounts || 0}</strong>
                            </Typography>
                            <Typography variant="subtitle2" color="text.secondary">

                            </Typography>

                            <Box display="flex" alignItems="center">
                                <Typography variant="subtitle1" color="text.primary" mr={0.5} sx={{ fontWeight: 'bold' }}>
                                    {percentage}%
                                </Typography>
                                {
                                    isGrowth ?
                                        <ArrowUpward style={{ color: 'green', fontSize: 20 }} /> :
                                        <ArrowDownward style={{ color: 'red', fontSize: 20 }} />
                                }

                            </Box>
                        </Box>
                        <Box display="flex" justifyContent="space-between">
                            <Box>
                                <Typography variant="subtitle2" color="text.secondary">
                                    New Accounts <Typography component="span" variant="subtitle2" color="text.primary"><strong>{data?.newActiveAccounts || 0}</strong></Typography>
                                </Typography>
                            </Box>

                            <Box>
                                <Typography variant="subtitle2" color="text.secondary">
                                    All Accounts <Typography component="span" variant="subtitle2" color="text.primary"><strong>{data?.totalAccounts || 0}</strong></Typography>
                                </Typography>
                            </Box>
                        </Box>
                        <DashboardCardInfo title={tooltipTitle}/>
                    </CardContent>
            }

        </Card>
    );
};

export default AccountsCard;
